/**
  OBSOLETE - use google tag manager service instead:
  src\frontend\services\google-tagmanager-service.js

 * Ported from Applications/TouchWeb/src/legacy/static/app/ui/layout/google-tagmanager.js
 * Best way to import this module is `import * as Analytics from 'analytics'`
 */

import * as Sentry from '@sentry/react';

type WindowWithDataLayer = Window & {
    dataLayer: Record<string, unknown>[];
    ga?: (
        command: string,
        eventName: string,
        category: string,
        variable?: string,
        value?: string,
        label?: string
    ) => void;
};

declare const window: WindowWithDataLayer;

type AnalyticsData = {
    category?: string;
    action?: string;
    label?: string;
    value?: string;
    hitCallback?: unknown[];
    userTriggered?: boolean;
};

export const pushToDataLayer = (payload: Record<string, unknown>) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
};
export const trackPageView = () =>
    window.ga
        ? window.ga('send', 'pageview', location.pathname)
        : pushToDataLayer({ event: 'trackPageview' });
export const isNonInteractive = (analyticsData: AnalyticsData) =>
    analyticsData.userTriggered === undefined
        ? true
        : !analyticsData.userTriggered;
/**
 * trackTiming
 * @param {*} category
 * @param {*} variable
 * @param {*} value
 * @param {*} label
 */
export const trackTiming = (
    category: string,
    variable: string,
    value: string,
    label = ''
) =>
    window.ga
        ? window.ga('send', 'timing', category, variable, value, label)
        : false;

/**
 * Track Analytics Event
 */
export const trackEvent = (analyticsData: AnalyticsData) => {
    if (!analyticsData) {
        return;
    }
    pushToDataLayer({
        event: 'trackEvent',
        eventCategory: analyticsData.category || '',
        eventAction: analyticsData.action || '',
        eventLabel: analyticsData.label || '',
        eventValue: analyticsData.value || '0',
        eventNonInteractive: isNonInteractive(analyticsData),
        hitCallback: analyticsData.hitCallback || []
    });

    Sentry.addBreadcrumb({
        type: 'default',
        level: 'info',
        category: isNonInteractive(analyticsData) ? 'tracking' : 'ui-action',
        message: 'Analytics Event',
        data: analyticsData
    });
};

// Export object for Sinon stubbing
export default {
    pushToDataLayer,
    trackEvent,
    trackPageView,
    trackTiming
};
